import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { CustomCol, GoBackLink, PageTitle, CustomCard, CustomIframe } from 'src/components'

interface PropsType {
  metabaseData: {
    loading: boolean,
    iframeUrl: string
  }
}

const MetabaseDataPageContent: React.FC<PropsType> = ({ metabaseData }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return <>
    <Row>
      <CustomCol>
        <GoBackLink link={'/admin'} label={t('Validate.GoBack')} />
      </CustomCol>
      <CustomCol>
        <div className={isMobile ? 'centered-div' : 'float-right'}>
          <PageTitle>{t('Metabase Data')}</PageTitle>
        </div>
      </CustomCol>
    </Row>

    <CustomCard loading={metabaseData.loading}>
      <CustomIframe src={metabaseData.iframeUrl} />
    </CustomCard>
  </>
}

export default MetabaseDataPageContent
